import { convertCustomCardsToCardType } from 'hooks/customCard'
import { useEffect, useState } from 'react'
import { useAppSelector } from 'redux/hooks'
import { CustomCard } from 'services/apiTypes/customCards.types'
import { CardType } from 'types/deck'

export const useMergeCardsWithDeckCards = (customCards: CustomCard[]) => {
  const cardMap = useAppSelector(state => state.deck.cardMap)

  const handleReplaceCustomCardsWithDeckCards = (): CardType[] => {
    const customCardsAsCardTypes = convertCustomCardsToCardType(customCards)
    const deckCards = Object.values(cardMap)

    const customCardIdsToDeckInternalId = deckCards.reduce(
      (acc, card) => {
        if (!card.customCard?.id) return acc
        return { ...acc, [card.customCard.id]: card }
      },
      {} as Record<number, CardType>,
    )

    const mergedCards = customCardsAsCardTypes.map(card => {
      const customCardId = card.customCard?.id
      if (!customCardId) return card

      if (customCardIdsToDeckInternalId[customCardId]) return customCardIdsToDeckInternalId[customCardId]

      return card
    })

    return mergedCards
  }

  const [mergedCards, setMergedCards] = useState(handleReplaceCustomCardsWithDeckCards())

  useEffect(() => {
    setMergedCards(handleReplaceCustomCardsWithDeckCards())
  }, [customCards, cardMap])

  return mergedCards
}
